import React from 'react';
import { Link } from 'react-router-dom';

const PostVacancyErrorMessage = ({ schoolId, vacancyId }) => (
	<span>
    Vacancy is not completed or Apply By date is in the past. Please go to <Link to={`/schools/${schoolId}/vacancies/${vacancyId}/vacancy-info`}>Vacancy Information</Link> and edit the vacancy details.
  </span>
);

export default PostVacancyErrorMessage;


// WEBPACK FOOTER //
// ./src/components/common/post-vacancy-error-message.js